export default __webpack_public_path__ + "assets/online-delivery.c76f8767.svg";